/**
 * assets/promo-bar-actie.js
 * Gedrag van sections/promo-bar-actie.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function(){ try{ var b=document.querySelector('[data-promo-ac]'); if(!b) return; var k='promo-ac-koishowweek'; if(sessionStorage.getItem(k)==='closed'){b.style.display='none';return;} var x=b.querySelector('[data-promo-ac-close]'); if(x) x.addEventListener('click',function(){ sessionStorage.setItem(k,'closed'); b.style.display='none'; }); }catch(e){} })();
